const MYINSIGHTS_ERRORS = {
  saleData: {
    PDRP_OPT_OUT: {
      code: 90,
      message:
        "Sales data for this account cannot be queried because of PDRP opt out"
    },
    INVALID_DATA_TYPE: {
      code: 91,
      message:
        "Encountered an error during sales data query. Please check your data type"
    },
    DEFAULT: {
      code: -3,
      message: "Error in Sales Data API"
    }
  }
};

export { MYINSIGHTS_ERRORS };
